import { trans } from '@spotahome/soyuz/client';

import { formatPrice } from '@spotahome/soyuz-currency';

import { APPLY_ON_INCLUDED } from '../../constants/costs';

import { capitalizeFirstLetter } from '../utils/stringUtils';

import PaymentTimelineSubtitle from './PaymentTimelineSubtitle';

export const getCostSubtitle = cost => (
  <PaymentTimelineSubtitle
    from={cost.coveredPeriod?.from || null}
    to={cost.coveredPeriod?.to || null}
    paymentTo={cost.payTo || null}
    frequency={cost.frequency || null}
  />
);

export const getTooltipText = (cost, index) => {
  if (index === 0 && cost.applyOn === APPLY_ON_INCLUDED) {
    return trans(
      'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.tooltip.fullMonth'
    );
  }

  if (index === 1 && cost.applyOn === APPLY_ON_INCLUDED) {
    return trans(
      'spotahomeBookingPaymentInfo.downPaymentFirstMonthStrategy.tooltip.partialMonth'
    );
  }

  return null;
};

export const formatCostTitle = type =>
  type
    .split('|')
    .map(part => trans(capitalizeFirstLetter(part.trim())))
    .join(' · ');

export const getBillValue = bill =>
  bill.payTo !== APPLY_ON_INCLUDED && bill.value === null
    ? trans('listing.bills.is-not-included')
    : bill.value;

export const getBillValueSubtitle = (bill, currencyCode) => {
  if (bill.value === null && bill.applyOn !== APPLY_ON_INCLUDED) {
    return trans('listing.bills.estimation-requested-to-landlord');
  }

  if (bill.applyOn === APPLY_ON_INCLUDED && bill.value > 0) {
    return trans('listing.bills.amount-included-no-type', {
      billAmount: formatPrice(bill.value, currencyCode),
      currency: ''
    });
  }

  return null;
};

export const DuringStaySectionTitle = ({
  title,
  frequency = null,
  payTo = null,
  titleClassName
}) => (
  <div>
    <h5 className={titleClassName}>{title}</h5>
    {(frequency || payTo) && (
      <div>
        <PaymentTimelineSubtitle frequency={frequency} paymentTo={payTo} />
      </div>
    )}
  </div>
);
